var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    { staticClass: "min-h-screen" },
    [
      _c(
        "v-app-bar",
        {
          class: _vm.$vuetify.breakpoint.smAndUp ? "px-6" : null,
          attrs: {
            app: "",
            color: "white",
            height: "64",
            "elevate-on-scroll": "",
          },
        },
        [
          _c(
            "a",
            { attrs: { href: "https://musicologielessons.com" } },
            [
              _c("jet-application-logo", {
                staticClass: "block w-auto",
                class: _vm.$vuetify.breakpoint.xs ? "h-6" : "h-9",
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex gap-2 justify-end" },
            [
              false
                ? _c(
                    "v-btn",
                    {
                      staticClass: "white--text soli-round",
                      attrs: {
                        outlined: "",
                        href: "/get-started",
                        color: "primary",
                      },
                    },
                    [_vm._v("Get Started")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "SoliBtn",
                {
                  staticClass: "white--text",
                  attrs: { gradient: "gradient-orange", href: "/login" },
                },
                [_vm._v("Login")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-main", [
        _c(
          "section",
          { attrs: { id: "hero" } },
          [
            _c(
              "v-row",
              { attrs: { "no-gutters": "" } },
              [
                _c(
                  "v-img",
                  {
                    attrs: {
                      "min-height":
                        "calc(100vh - " + _vm.$vuetify.application.top + "px)",
                      src: "instruments-blue-background.jpg",
                    },
                  },
                  [
                    _c(
                      "v-theme-provider",
                      { attrs: { dark: "" } },
                      [
                        _c(
                          "v-container",
                          { attrs: { "fill-height": "" } },
                          [
                            _c(
                              "v-row",
                              {
                                staticClass: "white--text mx-auto",
                                attrs: { align: "center", justify: "center" },
                              },
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "white--text text-center",
                                    attrs: { cols: "12", tag: "h1" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "text-sm-h4 text-h5" },
                                      [
                                        _vm._v(
                                          "\n                                        Simply Delightful Booking\n                                    "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "text-sm-h2 text-h3 font-weight-bold",
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        Schedule. Connect. Explore.\n                                    "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "align-self-end mt-3",
                                    attrs: { fab: "", outlined: "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.$vuetify.goTo("#about-me")
                                      },
                                    },
                                  },
                                  [
                                    _c("v-icon", [
                                      _vm._v("keyboard_double_arrow_down"),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "section",
          { attrs: { id: "about-me" } },
          [
            _c("div", { staticClass: "py-12" }),
            _vm._v(" "),
            _vm.$vuetify.breakpoint.smAndUp
              ? _c(
                  "v-container",
                  {
                    class: _vm.$vuetify.breakpoint.smAndUp
                      ? "text-start"
                      : "text-center",
                  },
                  [
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "4" } },
                          [
                            _c("v-img", {
                              staticClass: "mx-auto",
                              attrs: { width: "250", src: "App-Demo.gif" },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          {
                            staticClass: "align-self-center",
                            attrs: { cols: "8" },
                          },
                          [
                            _c(
                              "h2",
                              { staticClass: "text-h4 font-weight-bold mb-3" },
                              [
                                _vm._v(
                                  "\n                            We make scheduling easy\n                        "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("v-divider", { staticClass: "mb-3 soli-blue" }),
                            _vm._v(" "),
                            _c("div", { staticClass: "mx-auto text-h6 mb-4" }, [
                              _vm._v(
                                "\n                            Sick kid? Reschedule with a few taps. Can't get\n                            out of the house? Switch from in person to\n                            online. Need a change of pace? Try a new\n                            instrument. It takes just seconds.\n                        "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                staticClass: "soli-round float-left",
                                attrs: {
                                  color: "dark",
                                  href: "https://musicologielessons.com/get-started",
                                  outlined: "",
                                  large: "",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "grey--text text--darken-1 font-weight-bold",
                                  },
                                  [
                                    _vm._v(
                                      "\n                                Try your first lesson\n                            "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.$vuetify.breakpoint.xs
              ? _c(
                  "v-container",
                  { staticClass: "text-start" },
                  [
                    _c(
                      "h2",
                      { staticClass: "display-2 font-weight-bold mb-3" },
                      [
                        _vm._v(
                          "\n                    We make scheduling easy\n                "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("v-divider", { staticClass: "mb-3 soli-blue" }),
                    _vm._v(" "),
                    _c("v-img", {
                      staticClass: "mx-auto my-6",
                      attrs: { width: "300", src: "App-Demo.gif" },
                    }),
                    _vm._v(" "),
                    _c("v-col", [
                      _c(
                        "div",
                        { staticClass: "mx-auto title font-weight-light mb-8" },
                        [
                          _vm._v(
                            "\n                        Sick kid? Reschedule with a few taps. Can't get out\n                        of the house? Switch from in person to online. Need\n                        a change of pace? Try a new instrument. It takes\n                        just seconds.\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex justify-center" },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "soli-round",
                              attrs: {
                                color: "dark",
                                href: "https://musicologielessons.com/get-started",
                                outlined: "",
                                large: "",
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "grey--text text--darken-1 font-weight-bold",
                                },
                                [
                                  _vm._v(
                                    "\n                                Try your first lesson\n                            "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "py-12" }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "section",
          { staticClass: "grey lighten-3", attrs: { id: "features" } },
          [
            _c("div", { staticClass: "py-12" }),
            _vm._v(" "),
            _c(
              "v-container",
              { staticClass: "text-center" },
              [
                _c("h2", { staticClass: "text-h3 font-weight-bold mb-3" }, [
                  _vm._v("Features"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "py-4" }),
                _vm._v(" "),
                _c(
                  "v-row",
                  _vm._l(_vm.features, function ({ icon, title, text }, i) {
                    return _c(
                      "v-col",
                      { key: i, attrs: { cols: "12", md: "4" } },
                      [
                        _c(
                          "v-card",
                          {
                            staticClass: "py-12 px-4 soli-round",
                            attrs: { color: "grey lighten-5", flat: "" },
                          },
                          [
                            _c("v-theme-provider", { attrs: { dark: "" } }, [
                              _c(
                                "div",
                                [
                                  _c(
                                    "v-avatar",
                                    { attrs: { color: "primary", size: "88" } },
                                    [
                                      _c("v-icon", {
                                        attrs: { large: "" },
                                        domProps: { textContent: _vm._s(icon) },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                            _vm._v(" "),
                            _c("v-card-title", {
                              staticClass:
                                "justify-center font-weight-black text-uppercase",
                              domProps: { textContent: _vm._s(title) },
                            }),
                            _vm._v(" "),
                            _c("v-card-text", {
                              staticClass: "text-h6",
                              domProps: { textContent: _vm._s(text) },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "py-12" }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "section",
          { attrs: { id: "privacy" } },
          [
            _c("div", { staticClass: "py-12" }),
            _vm._v(" "),
            _c(
              "v-container",
              { staticClass: "text-center" },
              [
                _c("h2", { staticClass: "text-h4 font-weight-bold mb-3" }, [
                  _vm._v(
                    "\n                    Privacy Matters\n                "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "text-h6 mb-4" }, [
                  _vm._v(
                    "\n                    We'll never sell your data to 3rd parties\n                "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "v-row",
                  { staticClass: "py-4 justify-center" },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "soli-round justify-center",
                        attrs: {
                          color: "dark",
                          href: "/privacy",
                          outlined: "",
                          large: "",
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "grey--text text--darken-1 font-weight-bold",
                          },
                          [
                            _vm._v(
                              "\n                            Privacy Policy\n                        "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "py-12" }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "section",
          { staticClass: "grey lighten-3", attrs: { id: "stripe" } },
          [
            _c("div", { staticClass: "py-12" }),
            _vm._v(" "),
            _c(
              "v-container",
              [
                _vm.$vuetify.breakpoint.xs
                  ? _c("v-img", {
                      staticClass: "mx-auto",
                      attrs: { width: "200", src: "stripe_logo.png" },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "v-row",
                  [
                    _vm.$vuetify.breakpoint.smAndUp
                      ? _c(
                          "v-col",
                          {
                            staticClass: "align-self-center",
                            attrs: { cols: "4" },
                          },
                          [
                            _c("v-img", {
                              staticClass: "float-right",
                              attrs: { width: "200", src: "stripe_logo.png" },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "v-col",
                      {
                        class: _vm.$vuetify.breakpoint.smAndUp
                          ? "text-start"
                          : "text-center",
                        attrs: { cols: "12", sm: "8" },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "text-h4 font-weight-bold mb-3" },
                          [
                            _vm._v(
                              "\n                            Powered by Stripe\n                        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "text-body-1" }, [
                          _vm._v(
                            "\n                            All payment data is handled directly by our\n                            payment processor, Stripe, and never touches the\n                            Musicologie software. We chose to partner with\n                            Stripe for their incredible security and Level 1\n                            PCI Compliance. Stripe processes payments for\n                            thousands of companies like Lyft, Zoom and\n                            Amazon.\n                        "
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "py-12" }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("SiteFooter"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }